/* src/app/admin-dashboard/site-system/records/transaction-view/t-result-view/t-result-view.component.css */
/*# sourceMappingURL=t-result-view.component.css.map */
